export default "__VITE_ASSET__s8S1c5qf__"